import { SiBlogger } from 'react-icons/si';
import { DARK_GRAY } from '../../../styles/constants/color';
import styled from '@emotion/styled';

const Button = styled.button`
  width: auto;
  height: auto;
  text-align: center;
`;

interface Props {
  color?: string;
}

/**
 *  쏠카 블로그 새창 링크 버튼 컴포넌트
 * @param {string} color 버튼의 색깔 defalut: #666;
 *  */
function ScBlog({ color }: Props): JSX.Element {
  const onClick = (): void => {
    window.open('https://blog.naver.com/solecar');
  };
  return (
    <Button onClick={onClick}>
      <SiBlogger size={23} color={color || DARK_GRAY} />
    </Button>
  );
}

export default ScBlog;
